// @flow

import { useState, useEffect } from 'react';

import type { TaskInstance } from '../../common/typings';

export const BASE_VIEW = 'baseView';
export const TASK_VIEW = 'taskView';
export const TASK_LIST_VIEW = 'taskListView';

export default function useTaskViews(taskInstances: Array<TaskInstance>) {
  const [view, setView] = useState(BASE_VIEW);
  const [currentTask, setCurrentTask] = useState(null);
  const [shortenAnimations, setShortenAnimations] = useState(false);

  useEffect(() => {
    if (view === TASK_VIEW && currentTask) {
      const shiftTaskInstance = taskInstances.find(({ id }) => id === currentTask.id);
      if (shiftTaskInstance !== currentTask) {
        setCurrentTask(shiftTaskInstance);
      }
    }
  }, [taskInstances, currentTask, view]); // eslint-disable-line react-hooks/exhaustive-deps

  const viewTasks = () => {
    setShortenAnimations(true);
    if (taskInstances.length > 1) {
      setView(TASK_LIST_VIEW);
    } else {
      setTaskView(taskInstances[0]);
    }
  };

  const setTaskView = (task: TaskInstance) => {
    setCurrentTask(task);
    setView(TASK_VIEW);
  };

  const goBack = () => {
    if (currentTask && taskInstances?.length > 1) {
      setView(TASK_LIST_VIEW);
    } else {
      setView(BASE_VIEW);
    }
    setCurrentTask(null);
  };

  return {
    view,
    currentTask,
    viewTasks,
    setTaskView,
    goBack,
    shortenAnimations
  };
}
